import { useTheme, useTime } from "arkh";
import { DateTime } from "luxon";
import React from "react";
import { Platform, StyleSheet, View } from "react-native";
import { totalHours } from "./totalHours";

export const TimeBackgroundLines = React.memo(_TimeBackgroundLines);
function _TimeBackgroundLines(props: {
  boxWidth: number;
  left: number;
  startD: DateTime;
  headerHeight: number;
}) {
  const now = useTime(60000);
  const theme = useTheme();
  return (
    <>
      <View
        style={{
          position: "absolute",
          height: "100%",
          width: Platform.OS === "web" ? 2 : 1,
          top: props.headerHeight,
          backgroundColor: theme.negative,
          left:
            props.left +
            (now.diff(props.startD).as("minutes") / 30) * props.boxWidth,
        }}
      />
      {new Array(totalHours * 2).fill(0).map((_, i) => {
        return (
          <View
            key={i + ""}
            style={{
              position: "absolute",
              height: "100%",
              width: StyleSheet.hairlineWidth,
              backgroundColor: i % 2 === 0 ? "#eee" : "#ccc",
              left: props.left + (i + 1) * props.boxWidth,
              top: props.headerHeight,
            }}
          />
        );
      })}
    </>
  );
}
